import React from "react";

import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { flatten, uniq } from "lodash";

import { FaIcon } from "components/AgGridButtonIcon/agGridButtonIcon";
import { Chip, ChipWrapper } from "components/Chip";

import { Species } from "constants/species";

import { getNvdCattleWarnings, getNvdSheepWarnings } from "lib/nlisId";

const VENDOR_BRED_WARNING = "Vendor Bred";

const getNvdWarnings = (declarations, speciesId) => {
  if (speciesId === Species.SHEEP && declarations.length > 0) {
    return flatten(declarations.map(getNvdSheepWarnings));
  } else if (speciesId === Species.CATTLE && declarations.length > 0) {
    return flatten(declarations.map(getNvdCattleWarnings));
  }
  return [];
};

export const getNvdDeclarationWarnings = (declarations, speciesId) =>
  uniq(
    getNvdWarnings(declarations.filter(Boolean), speciesId).filter(
      warning => warning !== VENDOR_BRED_WARNING,
    ),
  );

const getWarningChipLabel = warning => warning.replace(/\s*Warning\b/i, "");

export const NVDWarningChip = React.memo(({ warning }) => (
  <ChipWrapper>
    <Chip color backgroundColor="warning" tooltip={warning}>
      <FaIcon icon={faExclamationCircle} />
      &nbsp;{getWarningChipLabel(warning)}
    </Chip>
  </ChipWrapper>
));

export const NVDWarningChips = React.memo(({ warnings }) =>
  uniq(warnings.filter(Boolean)).map(warning => (
    <NVDWarningChip key={warning} warning={warning} />
  )),
);

const NVDChipComponent = props => {
  const { declarations, speciesId, vendorBred, euEligible } = props;
  const warnings = getNvdWarnings(declarations, speciesId);

  const flattenedVendorBred = flatten(vendorBred);

  const flattenedEuEligible = flatten(euEligible);

  const areAllVendorBred =
    warnings.includes(VENDOR_BRED_WARNING) ||
    (flattenedVendorBred.length > 0 && flattenedVendorBred.every(Boolean));

  const areAllEuEligible =
    flattenedEuEligible.length > 0 && flattenedEuEligible.every(Boolean);

  const nvdDeclarationWarnings = getNvdDeclarationWarnings(
    declarations,
    speciesId,
  );

  if (warnings) {
    return (
      <ChipWrapper>
        {areAllVendorBred && (
          <Chip color backgroundColor="success" tooltip="Vendor Bred">
            VB
          </Chip>
        )}
        {areAllEuEligible && (
          <Chip color backgroundColor="success" tooltip="EU Eligible">
            EU
          </Chip>
        )}
        <NVDWarningChips warnings={nvdDeclarationWarnings} />
      </ChipWrapper>
    );
  } else {
    return null;
  }
};

export const NVDChip = React.memo(NVDChipComponent);
